export const CHECK_UNREAD_NOTIFICATIONS = 'CHECK_UNREAD_NOTIFICATIONS';
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';

export const ACTION_CENTER_CLICKED = 'ACTION_CENTER_CLICKED';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';



// WEBPACK FOOTER //
// ./src/features/notifications/actionTypes.js